import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
export const Divider = ({ vertical = false, className, ...rest }) => {
    const dividerClassNames = classNames("eds-divider", className, {
        "eds-divider--vertical": vertical,
    });
    return _jsx("hr", { "aria-hidden": "true", className: dividerClassNames, ...rest });
};
